import { useEffect, useCallback, useState } from "react";
// routes
import { ROUTES } from "@/core/router/routes";
import { useNavigate } from "react-router-dom";
import { getDashboardLink } from "@/shared/utils/link";
import { useSelector } from "@/core/redux/store";
//

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function CompanyFirstCreateGuard({ children }: Props) {
  const [firstLoad, setFirstLoad] = useState(true);
  const { me } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const [checked, setChecked] = useState(true);

  const check = useCallback(() => {
    if (me?.company?.status === "draft") {
      const href =
        getDashboardLink(ROUTES.Dashboard.Setting.Workspace.Create) +
        "?email=" +
        me?.email;

      navigate(href);
    } else {
      setChecked(true);
    }
  }, [me, navigate]);

  useEffect(() => {
    if (!firstLoad) {
      check();
    } else {
      setFirstLoad(false);
    }
     
  }, [check, firstLoad]);

  if (!checked) {
    return null;
  }

  return <>{children}</>;
}
